import React, { useState } from 'react';
import styles from './index.module.scss';


// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

// Components
import { Card, Table, Button } from 'react-bootstrap';
import jwtDecode from 'jwt-decode';
import AccStatusModal from '../AccStatusModal';
import EditModal from '../EditModal';

const UserItem = (props) => {

    const returnUserType = (uType) => {
        switch(uType) {
            case 'user': return 'Regular';
            case 'power_user': return 'Super Usuario';
            case 'repair': return 'Tecnico';
            case 'admin': return 'Administrador';
            default: 
                return 'Tipo de Usuario Desconocido';
        }
    }

    return (
        <tr>
            <td>{props.data.name}</td>
            <td>{props.data.lastname}</td>
            <td>{props.data.username}</td>
            <td>{returnUserType(props.data.rights)}</td>
            <td>{props.data.active ? 'Si' : 'No'}</td>
            <td>
                <Button className={styles.Button} size="sm" variant="secondary">Ver Info.</Button>
                {props.currentUserRole === 'admin' && <Button className={styles.Button} size="sm" variant="warning" onClick={props.onEditUser}>Editar</Button>}
                {(props.currentUserId !== props.data._id && props.currentUserRole === 'admin' && props.data.active) && <Button className={styles.Button} size="sm" variant="danger" onClick={() => props.onDeactivation()}>Desactivar Cuenta</Button>}
                {(props.currentUserRole === 'admin' && !props.data.active) && <Button className={styles.Button} size="sm" variant="success" onClick={() => props.onActivation()}>Activar Cuenta</Button>}
                <Button variant="dark" onClick={() => props.viewUserClocks(props.data._id)} size="sm">
                    <FontAwesomeIcon icon={faClock} /> Tiempo
                </Button>
            </td>
        </tr>
    )
};


const UserList = (props) => {
    const currentUserData = jwtDecode(sessionStorage.getItem('auth-token'));
    const [accountSelected, setAccountSelected] = useState(null);
    const [showAccStatusModal, setShowAccStatusModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [isActivating, setIsActivating] = useState(false);

    const changeAccountActiveStatus = async () => {
        const url = `${process.env.REACT_APP_API_URL}/users/${accountSelected}`;
        const token = sessionStorage.getItem('auth-token');
        
        const request = await fetch(url, {
            method: 'PATCH',
            body: JSON.stringify({
                active: isActivating
            }),
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            }
        });

        if(request.status === 200) {
            setShowAccStatusModal(false);
            
            //Refresh the accounts
            refreshAccounts();
            
        } else {
            alert('The deactivaction failed');
        }
    };

    const onChangeStatusHandler = (status, userId) => {
        setIsActivating(status);
        setShowAccStatusModal(true);
        setAccountSelected(userId);
    }

    const onChangeInfoHandler = (userId) => {
        setShowEditModal(true);
        setAccountSelected(userId)
    };

    const refreshAccounts = () => {
        // Refresh the update count
        props.setUpdateCount(count => count + 1);
    }

    return (
        <>
            <Card className={styles.MessagesList}>
                <Card.Body>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Apellido</th>
                                <th>Usuario</th>
                                <th>Permisos</th>
                                <th>Activo</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.users.map(userData => (
                                <UserItem 
                                    key={userData._id} 
                                    data={userData} 
                                    currentUserId={currentUserData.id} 
                                    currentUserRole={currentUserData.rights}
                                    onActivation={() => onChangeStatusHandler(true, userData._id)}
                                    onDeactivation={() => onChangeStatusHandler(false, userData._id)}
                                    onEditUser={() => onChangeInfoHandler(userData._id)}
                                    viewUserClocks={props.viewUserClocks} />
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
            <AccStatusModal 
                show={showAccStatusModal} 
                hide={() => setShowAccStatusModal(false)}
                onSuccess={changeAccountActiveStatus}
                activate={isActivating} />
            <EditModal 
                show={showEditModal}
                hide={() => setShowEditModal(false)}
                user={accountSelected}
                refreshAccounts={refreshAccounts} />
        </>
    );
}

export default UserList;